export const ROUTES = {
  welcome: '/louvre/welcome',
  welcomeWithToken: '/louvre/welcome/:token',
  welcomeNoToken: '/louvre/welcome',
  unauthenticated: '/louvre/unauthenticated',
  unauthorized: '/louvre/unauthorized',
  pageNotFound: '/error/404',
  serverError: '/error/500',
  home: '/parcours',
  root: '/',
  confirmationPage: '/louvre/confirmation',
  maintenancePage: '/maintenance',
}
